import React, { useCallback } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { Bold, Button, Card } from './shared_toast';
import MarkAllAsRead from 'actions/agent_notifications/mark_all_as_read';
import { useExecuteAction } from 'components/hooks/connect_hooks';

export function UnreadNotificationsToast({ toast }) {
  const { t } = useTranslation();
  const executeAction = useExecuteAction();

  const { numUnread } = toast.content;

  const navigateToMention = useCallback(() => {
    executeAction(MarkAllAsRead);
  }, []);
  const action = <Button onClick={navigateToMention}>{t('Mark all as read')}</Button>;

  return (
    <Card action={action} toast={toast}>
      <Trans
        components={{ bold: <Bold /> }}
        i18nKey="You have <bold>{{numUnread}}</bold> unread notifications"
        values={{ numUnread }}
      />
    </Card>
  );
}

export default UnreadNotificationsToast;
